import React, { useState } from 'react';
import { Twitter, Facebook, Linkedin } from 'lucide-react';

const socialLinks = [
  { href: '#', label: 'Twitter', icon: <Twitter color="var(--color-primary)" size={24} /> },
  { href: '#', label: 'Facebook', icon: <Facebook color="var(--color-primary)" size={24} /> },
  { href: '#', label: 'LinkedIn', icon: <Linkedin color="var(--color-primary)" size={24} /> },
];

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    // Simple email validation
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setSubmitted(true);
    setEmail('');
    // Here you would send the email to your backend/newsletter service
  };

  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-4 sm:py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 sm:gap-6 md:gap-8 items-start">
          <div>
            <h3 className="text-base sm:text-lg md:text-xl font-bold text-primary mb-2 sm:mb-3 md:mb-4">White Curve</h3>
            <p className="text-gray-600 text-xs sm:text-sm">AI-powered study assistant for better exam preparation.</p>
          </div>
          <div className="hidden md:block">
            <h4 className="font-semibold mb-2 md:mb-4 text-xs md:text-base">Product</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><a href="#features" className="text-gray-600 hover:text-primary text-xs md:text-sm">Features</a></li>
              <li><a href="#how-it-works" className="text-gray-600 hover:text-primary text-xs md:text-sm">How it Works</a></li>
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Pricing</a></li>
            </ul>
          </div>
          <div className="hidden md:block">
            <h4 className="font-semibold mb-2 md:mb-4 text-xs md:text-base">Resources</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Documentation</a></li>
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Guides</a></li>
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Support</a></li>
            </ul>
          </div>
          <div className="hidden md:block">
            <h4 className="font-semibold mb-2 md:mb-4 text-xs md:text-base">Legal</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-primary text-xs md:text-sm">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t mt-4 sm:mt-6 md:mt-12 pt-2 sm:pt-4 md:pt-8 text-center text-gray-600 text-xs sm:text-sm">
          <p>&copy; {new Date().getFullYear()} White Curve. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 